import { FiltersState } from '@/types/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Asset } from '@/types/asset_search';

const initialFilterState: FiltersState = {
  assetTable: {
    search: '',
    assetFiltered: [],
    refetch: false,
  },
};

const filtersSlice = createSlice({
  name: 'filter',
  initialState: initialFilterState,
  reducers: {
    setAssetTableSearchFilter(state, action: PayloadAction<string>) {
      state.assetTable.search = action.payload;
    },
    setAssetTableFiltered(state, action: PayloadAction<Asset[]>) {
      const prevAssets = state.assetTable?.assetFiltered || [];

      state.assetTable.assetFiltered = action.payload.map((newAsset) => {
        const prevAsset = prevAssets.find(
          (asset) => asset.asset_uuid === newAsset.asset_uuid,
        );

        return {
          ...newAsset,
          markedAsFound: prevAsset ? prevAsset.markedAsFound : false,
        };
      });
    },
    setAssetMarkedAsFound(
      state,
      action: PayloadAction<{ assetUuid: string; checked: boolean }>,
    ) {
      state.assetTable.assetFiltered.map((asset) => {
        if (asset.asset_uuid === action.payload.assetUuid) {
          asset.markedAsFound = action.payload.checked;
        }
      });
    },
    setAssetTableRefetch(state, action: PayloadAction<boolean>) {
      state.assetTable.refetch = action.payload;
    },
  },
});

export const {
  setAssetTableSearchFilter,
  setAssetTableFiltered,
  setAssetMarkedAsFound,
  setAssetTableRefetch,
} = filtersSlice.actions;

export default filtersSlice.reducer;
